// extracted by mini-css-extract-plugin
export default {"analyses-form":"analyses_analyses-form__dwb1y","content":"analyses_content__gogqL","toolbar":"analyses_toolbar__rbYm7"};